
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ocean-pro-consultation",
      function () {
        return require("private-next-pages/ocean-pro-consultation/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ocean-pro-consultation"])
      });
    }
  